export const ACCOUNTANT_HOME = "/rider-settlement";

export const ACCOUNTANT_ROUTES = [
  "/deliveryboy-reports",
  "/reports",
  "/payouts",
  "/rider-settlement",
  "/restaurant-settlement",
  "/delivery-boys",
  "/deliboy/:id",
  "/orderID/:id",
];

export const accountantMayOpen = (routePath) => ACCOUNTANT_ROUTES.includes(routePath);
